<script>
export default {
  props: {
    module: Object,
  },
  computed: {
    linkAddClient() {
      let href = '/tourclient/admin/clients/add_full.html';
      if (this.module.id) {
        href += `?from=clientlist&phoneCallId=${encodeURIComponent(this.module.id)
        }&phoneNumber=${encodeURIComponent(this.module.number)}`;
      }
      return href;
    },
    linkAddLead() {
      let href = '/tourclient/admin/leads/edit_full.html';
      href += this.module.id ? `?phoneCallId=${encodeURIComponent(this.module.id)}&` : '?';
      if (this.module.contact) {
        href += `ClientId=${this.module.contact.value}`;
      } else {
        href += `ClientPhone=${this.module.number}`;
      }
      return href;
    },
  },
  methods: {
    close() {
      this.module.close();
    },
  },
};
</script>
<template>
  <div class="ma-3" v-if="module.show">
    <v-list
      :min-width="420"
      class="pa-0"
      >
      <v-sheet
        :elevation="6"
      >
        <v-list-item>
          <v-list-item-action>
            <v-icon v-text="'mdi-phone'"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ module.label }}</v-list-item-title>
            <v-list-item-subtitle>
              <div v-if="module.external">Линия: {{ module.external }}</div>
              <div v-if="module.contact">
                <a :href="module.contact.url" target="_blank">
                  От: {{ module.contact | label }} ({{ module.number }})
                </a>
                <div v-if="module.contact.length">{{ module.contact.length }}</div>
              </div>
              <div v-if="!module.contact">
                От: {{ module.number }}
                <div>
                  <a :href="linkAddClient" target="_blank">Добавить клиента</a>
                </div>
              </div>
              <div v-if="module.lead">
                Лид: <a :href="module.lead.url" target="_blank">{{ module.lead | label }}</a>
              </div>
              <div v-if="!module.lead">
                Лид: <a :href="linkAddLead" target="_blank">Добавить</a>
              </div>
              <div v-if="module.preorder">
                <a :href="module.preorder" target="_blank">Добавить предзаказ</a>
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              title="Скрыть"
              icon
              @click="close"
            >
              <v-icon v-text="'mdi-close-circle-outline'"></v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-sheet>
    </v-list>
  </div>
</template>
<style lang="scss">
  .mag-template-phone {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 10000;
  }
</style>
